export default __webpack_public_path__ + "static/media/Tasset of Violent Rage.99021706.jpg";